exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._2PXNIXELYe4_ziKh6eLn1X{width:300px}html[dir] ._2PXNIXELYe4_ziKh6eLn1X{background-color:\"[theme:white, default:#ffffff]\"}._3xUE8v4N7nr4HeLekbAwmt{-webkit-animation:none!important;animation:none!important}.bqD0MJwzfp_uEviWVS4k1{max-height:470px;overflow-x:hidden}.NsTJlENCm_pRtHjDy2K2Q{overflow:hidden}", ""]);

// exports
exports.locals = {
	"callout": "_2PXNIXELYe4_ziKh6eLn1X",
	"animationStop": "_3xUE8v4N7nr4HeLekbAwmt",
	"scrollContainer": "bqD0MJwzfp_uEviWVS4k1",
	"recipientCollection": "NsTJlENCm_pRtHjDy2K2Q"
};